<div class="billing-summary">
  <div class="stat-card">
    <h3>{{ "billing.status.BILLABLE" | translate }}</h3>
    <p>
      <strong>{{ "billing.summary.visible" | translate }} :</strong> {{ billableVisible }}
    </p>
    <p>
      <strong>{{ "billing.summary.total" | translate }} :</strong> {{ billableTotal }}
    </p>
  </div>
  <div class="stat-card">
    <h3>{{ "billing.status.PLANNED" | translate }}</h3>
    <p>
      <strong>{{ "billing.summary.visible" | translate }} :</strong> {{ plannedVisible }}
    </p>
    <p>
      <strong>{{ "billing.summary.total" | translate }} :</strong> {{ plannedTotal }}
    </p>
  </div>
</div>
